import {Select} from 'antd';
import compose from 'lodash/fp/compose';
import map from 'lodash/fp/map';
import values from 'lodash/values';
import PropTypes from 'prop-types';
import React, {memo, useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {NOTARIAL_PROCEDURE_TYPE} from '@/modules/company/components/ProcedureNotarialProcedureType';

const NotaryProcedureTypesSelect = ({value, onChange}) => {
  const {t} = useTranslation('company');
  
  const options = useMemo(() => compose(
    map((value) => ({value, label: t(`procedure.notaryProcedure.${value}`)})),
    values,
  )(NOTARIAL_PROCEDURE_TYPE), [t]);
  
  return (
    <Select
      value={value}
      options={options}
      onChange={onChange}/>
  );
  
};

NotaryProcedureTypesSelect.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
};

NotaryProcedureTypesSelect.defaultProps = {};

export default memo(NotaryProcedureTypesSelect);
